import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { EffectsPluginService } from './effects.service';
import { UntypedFormControl, UntypedFormGroup, UntypedFormArray, UntypedFormBuilder } from '@angular/forms';
import { ModalComponent } from '../../modal/modal.component';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { BaseModalPageComponent } from '../../base-modal.component';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

@Component({
  selector: 'effects-edit',
  templateUrl: './effects-edit.component.html',
  standalone: false
})
export class EffectsEditPageComponent extends BaseModalPageComponent implements OnInit, OnDestroy {
  plugin: any;
  editForm: UntypedFormGroup;
  ratingOptions = [1, 2, 3];
  inspectionId: string;
  pointId: string;
  pluginId: string;
  public processing = false;
  private currentControlName: string;
  private currentEffectIndex: number;
  private effectToRemove: number;

  private sub = new Subscription();

  @ViewChild('ratingModal', { static: true }) ratingModal: ModalComponent;
  @ViewChild('menuModal', { static: true }) menuModal: ModalComponent;
  @ViewChild('pluginDeleteConfirm', { static: true }) pluginDeleteConfirm: any;
  @ViewChild('effectDeleteConfirm', { static: true }) effectDeleteConfirm: any;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: EffectsPluginService,
    private fb: UntypedFormBuilder
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService.updateEffects(this.inspectionId, this.pointId, this.pluginId, model.effects).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  public onClose(e: any) {
    this.editForm.markAsTouched();
  }

  public openRatingSelector(index: number, controlName: string) {
    this.currentEffectIndex = index;
    this.currentControlName = controlName;
    const control = (<UntypedFormArray>this.editForm.controls['effects']).at(index).get(controlName);
    const options = this.ratingOptions.map((rating) => ({ value: rating, label: rating.toString() }));
    this.openSelector(this.ratingModal, options, control.value);
  }

  public selectRatingMenu(item: any) {
    const control = (<UntypedFormArray>this.editForm.controls['effects']).at(this.currentEffectIndex).get(this.currentControlName);
    control.setValue(item.value?.value);
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  gotoEditJsonPage() {
    return this.router.navigate([this.inspectionsRoute, this.inspectionId, 'points', this.pointId, 'plugins', this.pluginId, 'editjson']);
  }

  gotoEditPage() {
    return this.router.navigate([this.inspectionsRoute, this.inspectionId, 'points', this.pointId, 'plugins', this.pluginId, 'edit']);
  }

  public deletePlugin() {
    this.pluginService.deletePlugin(this.inspectionId, this.pointId, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }

  public openDeleteConfirm() {
    this.pluginDeleteConfirm.open();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);
      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);
      this.pointId = pointId;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();
      this.pluginId = pluginId;

      this.initData();
    });
  }

  private initData() {
    this.pluginService.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = this.fb.group({
      effects: this.fb.array([])
    });

    const control = <UntypedFormArray>this.editForm.controls['effects'];
    _.forEach(this.plugin.config.Effects, (el) => {
      control.push(this.initEffect(el));
    });
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['effects'];
  }

  add() {
    const control = <UntypedFormArray>this.editForm.controls['effects'];
    control.push(this.initEffect());
  }

  initEffect(el?: any) {
    return this.fb.group({
      Realibility: new UntypedFormControl(el && el.Realibility != null ? el.Realibility : null),
      Perfomance: new UntypedFormControl(el && el.Perfomance != null ? el.Perfomance : null),
      AccuracyAndQuality: new UntypedFormControl(el && el.AccuracyAndQuality != null ? el.AccuracyAndQuality : null),
      Safety: new UntypedFormControl(el && el.Safety != null ? el.Safety : null),
      Actions: new UntypedFormControl(el && el.Actions ? el.Actions : '')
    });
  }

  remove(e: any) {
    const control = <UntypedFormArray>this.editForm.controls['effects'];
    control.removeAt(this.effectToRemove);
  }

  openEffectDeleteConfirm(i: number) {
    this.effectDeleteConfirm.open();
    this.effectToRemove = i;
  }
}
